'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M64 0v1024h896v-1024h-896zM896 960h-768v-896h768v896zM192 192h320v64h-320v-64zM192 320h320v64h-320v-64zM192 448h320v64h-320v-64zM192 575.36h320v64h-320v-64zM192 704h320v64h-320v-64zM192 832h640v64h-640v-64zM832 218.508l-37.49 37.492 37.49 37.492v26.508h-64v64h-26.51l-37.49-37.49-37.49 37.49h-26.51v-64h-64v-26.508l37.49-37.492-37.49-37.492v-26.508h64v-64h26.51l37.49 37.49 37.49-37.49h26.51v64h64v26.508z' }),
        React.createElement('path', { d: 'M768 448v288l-64-64-64 64v-288z' })
    ));
};